import { Component, OnInit } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { AppEnum } from '../../../providers/app.enum';
import { AppServiceService } from 'src/app/app-service.service';
declare var $;

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss'],
})

export class StartComponent implements OnInit {
  public setLanguage;
  public appSetting;
  public IsMore = 0;
  public secondsInterval = null;
  public urlSysIdd;
  public dbJsonn;

  constructor(public router: Router, public appEnum: AppEnum, public appService: AppServiceService) { }

  ngOnInit() {
    const jsonData = this.appService.decryptData(localStorage.getItem('LogInDetails'));
    this.appSetting = JSON.parse(jsonData);
    const ths = this;
    setTimeout(() => {
      this.IsMore = 0;
      $('.up-container').css('bottom', '0px');
      $('.up-container').css('transition', '1s');
      $('#icon-up-down').removeClass('fa-angle-double-down');
      $('#icon-up-down').addClass('fa-angle-double-up');
    }, 5000);

    if (this.appSetting.Language === this.appEnum.Entitylanguage.language_english) {
      this.setLanguage = this.appEnum.English;
    } else if (this.appSetting.Language === this.appEnum.Entitylanguage.language_chinese) {
      this.setLanguage = this.appEnum.Chinese;
    } else {
      this.setLanguage = this.appEnum.English;
    }
    this.urlSysIdd = this.appService.serviceURL + 'CheckStatus';
    this.appSetting = JSON.parse(jsonData);
          console.log(this.appSetting.ClientId);
          this.dbJsonn = {
            ClientId:this.appSetting.ClientId,

          };
          
      ths.appService.postData(ths.urlSysIdd, ths.dbJsonn).subscribe(data => {
        if (data.status === 0) {
          localStorage.removeItem('LogInDetails');
          localStorage.removeItem('AdminDetails');
          window.location.reload(); 
          
        }
      });

      
  }

  
  showMore() {
    if (this.IsMore === 0) {
      this.IsMore = 1;
      $('.up-container').css('bottom', '80px');
      $('.up-container').css('transition', '1s');

      $('#icon-up-down').removeClass('fa-angle-double-up');
      $('#icon-up-down').addClass('fa-angle-double-down');

    } else {
      this.IsMore = 0;
      $('.up-container').css('bottom', '0px');
      $('.up-container').css('transition', '1s');
      $('#icon-up-down').removeClass('fa-angle-double-down');
      $('#icon-up-down').addClass('fa-angle-double-up');
    }

    if (this.IsMore === 1) {
      setTimeout(() => {
        this.IsMore = 0;
        $('.up-container').css('bottom', '0px');
        $('.up-container').css('transition', '1s');
        $('#icon-up-down').removeClass('fa-angle-double-down');
        $('#icon-up-down').addClass('fa-angle-double-up');
      }, 5000);
    }
  }

  logout() {
    localStorage.removeItem('LogInDetails');
    this.router.navigateByUrl('/Patient/Login');
  }

  gotoNextPage() {
    const ths = this;
    ths.appService.postData(ths.urlSysIdd, ths.dbJsonn).subscribe(data => {
      if (data.status === 0) {
        alert("Your Clinic is deactivated, Please contact your CSA to activate.");

        localStorage.removeItem('LogInDetails');
        localStorage.removeItem('AdminDetails');
        window.location.reload(); 
        
      }else{
        if (this.appSetting.Language === 'English') {
          this.router.navigateByUrl('/Patient/Patient-Type');
        } else {
          this.router.navigateByUrl('/Patient/Patient-Info');
        }
      }
    });
    
  }
}
